import { CheckCircle, HandCoins, X } from "lucide-react";

// Cash Modal Component
export const CashModal = ({ show, cashCollections, cashTotals, reporting, onClose, onRefresh, onReport }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-end">
      <div className="bg-white/10 backdrop-blur-lg rounded-t-3xl border-t border-white/20 w-full max-h-[80vh] overflow-y-auto">
        <div className="flex items-center justify-between p-4 border-b border-white/20">
          <h3 className="text-white font-bold text-xl">Cash de încasat</h3>
          <button
            onClick={onClose}
            className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center text-gray-400 hover:text-white"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        <div className="p-4 space-y-4">
          <div className="grid grid-cols-2 gap-3">
            <div className="bg-white/10 rounded-xl p-4 text-center">
              <p className="text-2xl font-bold text-red-400">{cashTotals.pending.toLocaleString('ro-RO')} RON</p>
              <p className="text-xs text-gray-400">De încasat</p>
            </div>
            <div className="bg-white/10 rounded-xl p-4 text-center">
              <p className="text-2xl font-bold text-green-400">{cashTotals.collected.toLocaleString('ro-RO')} RON</p>
              <p className="text-xs text-gray-400">Raportate</p>
            </div>
          </div>

          <div className="space-y-3">
            <h4 className="text-white font-medium">Istoric cash</h4>
            
            {cashCollections.length === 0 ? (
              <div className="bg-white/5 rounded-xl p-6 text-center">
                <HandCoins className="w-12 h-12 text-gray-400 mx-auto mb-2" />
                <p className="text-gray-300">Nu aveți cash de încasat momentan</p>
              </div>
            ) : (
              cashCollections.map((collection) => (
                <div key={collection.id} className="bg-white/10 rounded-xl p-4 border border-white/20">
                  <div className="flex items-start justify-between mb-3">
                    <div className="flex-1">
                      <p className="text-white font-medium">{collection.client}</p>
                      <p className="text-gray-400 text-sm">{collection.destinatie}</p>
                    </div>
                    <div className="text-right">
                      <p className="text-green-300 font-bold text-lg">
                        {parseFloat(collection.amount).toLocaleString('ro-RO')} RON
                      </p>
                      <span className={`px-2 py-1 rounded-lg text-xs ${
                        collection.status === 'pending' 
                          ? 'bg-orange-500/20 text-orange-300 border border-orange-500/30' 
                          : 'bg-green-500/20 text-green-300 border border-green-500/30'
                      }`}>
                        {collection.status === 'pending' ? 'De încasat' : 'Raportat'}
                      </span>
                    </div>
                  </div>

                  {collection.status === 'collected' && collection.reported_at && (
                    <div className="border-t border-white/20 pt-3 mt-3">
                      <div className="flex items-center space-x-2 text-green-400 text-sm">
                        <CheckCircle className="w-4 h-4" />
                        <span>Raportat: {new Date(collection.reported_at).toLocaleString('ro-RO')}</span>
                      </div>
                    </div>
                  )}
                </div>
              ))
            )}
          </div>

          <div className="pt-4 border-t border-white/20">
            <button
              onClick={onRefresh}
              className="w-full bg-blue-500/20 hover:bg-blue-500/30 text-blue-300 border border-blue-500/30 rounded-xl py-2 px-4 text-sm font-medium"
            >
              Reîmprospătează
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};